
import { routes } from '../config/api_routes'

export const productBrandService = {

    getproductBrand: (formData) => {
        return window.axios.post(routes.getproductBrandApi, formData)
    },
    
    addproductBrand: (formData) => {
        return window.axios.post(routes.addproductBrandApi, formData)
    },
    
    getProductBrandById: (formData) => {
        return window.axios.post(routes.getProductBrandByIdApi, formData)
    },
    
    editproductBrand: (formData) => {
        return window.axios.post(routes.editproductBrandApi, formData)
    },
    
    deleteProductBrand: (formData) => {
        return window.axios.post(routes.deleteProductBrandApi, formData)
    },


    // Producer Compnay

    addProducerCompany: (formData) => {
        return window.axios.post(routes.addProducerCompanyApi, formData)
    },

    getProducerCompany: (formData) => {
        return window.axios.post(routes.getProducerCompanyApi, formData)
    },

    getProducerCompanyById: (formData) => {
        return window.axios.post(routes.getProducerCompanyByIdApi, formData)
    },
    
    editProducerCompany: (formData) => {
        return window.axios.post(routes.editProducerCompanyApi, formData)
    },
    
    deleteProducerCompany: (formData) => {
        return window.axios.post(routes.deleteProducerCompanyApi, formData)
    },


    // Producer Brand

    addProducerBrand: (formData) => {
        return window.axios.post(routes.addProducerBrandApi, formData)
    },

    getProducerBrand: (formData) => {
        return window.axios.post(routes.getProducerBrandApi, formData)
    },

    getProducerBrandById: (formData) => {
        return window.axios.post(routes.getProducerBrandByIdApi, formData)
    },
    
    editProducerBrand: (formData) => {
        return window.axios.post(routes.editProducerBrandApi, formData)
    },
    
    deleteProducerBrand: (formData) => {
        return window.axios.post(routes.deleteProducerBrandApi, formData)
    },
}